import DragAttachmentContainer from './container';

export default DragAttachmentContainer;
